import SvgPause from '@sats-group/icons/18/pause';
import SvgPlay from '@sats-group/icons/18/play';
import Button from '@sats-group/ui-lib/react/button';
import React from 'react';
import type { VideoTrigger as Props } from './video-trigger.types';

const VideoTrigger: React.FC<Props> = ({
  isPlaying,
  play,
  pause,
  playLabel,
  pauseLabel,
}) => {
  const onClick = isPlaying ? pause : play;

  return (
    <Button
      iconOnly
      leadingIcon={isPlaying ? <SvgPause /> : <SvgPlay />}
      onClick={onClick}
      text={isPlaying ? pauseLabel : playLabel}
      variant={Button.variants.secondaryWhite}
    />
  );
};

export default VideoTrigger;
